/*
 *
 */
"use strict";

/*
 *
 */
Entry.BlockExtension = function (content, blockView) {};
(function (p) {})(Entry.BlockExtension.prototype);